import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';

const EmptyValue = styled.div`
  height: 100%;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    border-top: 2px solid ${(props) => props.theme.colors.dark};
    width: 12px;
  }
`;

const Value = styled.p`
  span {
    margin-right: 9px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }
`;

const Cell = ({ value, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {value && value.value && value.rank ? (
      <Value>
        <span>#{value.rank}</span>
        {value.value}
      </Value>
    ) : (
      <EmptyValue>
        <div />
      </EmptyValue>
    )}
  </CellContainer>
);

export default Cell;
